// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"VE-z","smallCardRow":"WE-z","largeCardRow":"XE-z","productSearchRow":"YE-z","curatedRow":"ZE-z"};